import { render } from "./ConstructorTable.vue?vue&type=template&id=2ec62fd8"
import script from "./ConstructorTable.vue?vue&type=script&lang=js"
export * from "./ConstructorTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__